import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ConfigurationService,
  DisplayService,
  IncidentalAbsence,
  Session,
  UserRoleService,
} from '../..';
import { EditAbsenceDialogComponent } from 'src/app/my-sedgwick';
import { Router } from '@angular/router';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { IncidentalAbsenceDialogParams } from '../../models/indicental-absence-dialog-params';

@Component({
    selector: 'app-absence-summary',
    template: `
    <app-panel [title]="title" [sentenceCase]="sentenceCase" [headerLevel]="1">
      @if (display.reportClaimSignal()) {
        <app-action-row class="tw-w-full">
          <app-button right1 emphasis="High" (click)="reportClaim()" label="Submit an absence"
          ></app-button>

          </app-action-row>
        }
        <app-absence-grid
          [absences]="absences"
          [filterEnabled]="true"
          [employeeLinkEnabled]="false"
          [absencesLoading]="absencesLoading"
          [translationRequest]="translationRequest"
        ></app-absence-grid>
    
        <ng-template #dialogReportNewClaim>
          <app-dialog
            title="Confirmation"
            [width]="700"
            [showActions]="false"
            [showHeader]="false"
            ariaLabel="Confirmation dialog"
            ariaLabelMessage="Close announcement popup"
            >
            <app-report-new-claim></app-report-new-claim>
          </app-dialog>
        </ng-template>

        <ng-template #addAbsenceDialog>
          <app-absence-add-dialog></app-absence-add-dialog>
        </ng-template>
      </app-panel>
    `,
    styles: [],
    standalone: false
})
export class AbsenceSummaryComponent implements OnInit {
  @ViewChild('dialogReportNewClaim') dialogRefReportNewClaim: TemplateRef<any>;
  @Input()
  title: string;

  @Input()
  sentenceCase: boolean = true;

  @Input()
  absences: IncidentalAbsence[];

  @Input()
  absencesLoading: boolean;

  @Input()
  incidentalAbsenceDialogParams: IncidentalAbsenceDialogParams;

  @ViewChild('addAbsenceDialog') addAbsenceDialogRef: TemplateRef<any>;
  
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Absences',
    subGroup: 'Absences',
  });

  hasReportClaim = false;
  isIncAbsence: boolean = false;

  constructor(
    private session: Session,
    public dialog: MatDialog,
    private config: ConfigurationService,
    private router: Router,
    public display: DisplayService,
    public userRole: UserRoleService
  ) {}

  async ngOnInit() {
    this.isIncAbsence = await this.config.getConfigFeatureAccess(
      'IncidentalAbsence'
    );
    this.hasReportClaim =
      !this.session.user.hasIntake ||
      this.session.user.hasIntake === undefined ||
      (this.isIncAbsence && this.userRole.employee)
        ? false
        : true;
  }

  openEditAbsencePopup(absence: IncidentalAbsence) {
    const dialogRef = this.dialog.open(EditAbsenceDialogComponent);
    const instance = dialogRef.componentInstance;
    instance.dialogRef = dialogRef;
    instance.absence = absence;
  }

  reportClaim() {
    if (this.config.getConfigFeatureAccess('IncidentalAbsences5')) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Confirmation',
      };
      this.dialog.open(this.dialogRefReportNewClaim, dialogConfig);
    } else if (this.config.getConfigFeatureAccess('IncidentalAbsence')) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        employeeId: this.incidentalAbsenceDialogParams.empId,
        employeeName: this.incidentalAbsenceDialogParams.empName,
        employeeUid: this.incidentalAbsenceDialogParams.hrMasterUid,
        empUnum: this.incidentalAbsenceDialogParams.empUnum,
        encryptedEmployeeId: this.incidentalAbsenceDialogParams.encryptedEmployeeId,
      };
      this.dialog.open(this.addAbsenceDialogRef, dialogConfig);
    } else {
      this.router.navigate(['employeeSearch'], {});
    }
  }
}
